/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const ACCPSUPERVISOR_ADD = 'ACCPSUPERVISOR_ADD';
export const ACCPSUPERVISOR_BEGIN = 'ACCPSUPERVISOR_BEGIN';
export const ACCPSUPERVISOR_FAILURE = 'ACCPSUPERVISOR_FAILURE';
export const ACCPSUPERVISOR_CLEAR = 'ACCPSUPERVISOR_CLEAR';

export const ACCPSUPERVISOR_FILTER_BEGIN = 'ACCPSUPERVISOR_FILTER_BEGIN';
export const ACCPSUPERVISOR_FILTER_SUCCESS = 'ACCPSUPERVISOR_FILTER_SUCCESS';
export const ACCPSUPERVISOR_FILTER_FAILURE = 'ACCPSUPERVISOR_FILTER_FAILURE';
export const ACCPSUPERVISOR_FILTER_CLEAR = 'ACCPSUPERVISOR_FILTER_CLEAR';

export const ACCPSUPERVISORAVAILABLE_ADD = 'ACCPSUPERVISORAVAILABLE_ADD';
export const ACCPSUPERVISORAVAILABLE_BEGIN = 'ACCPSUPERVISORAVAILABLE_BEGIN';
export const ACCPSUPERVISORAVAILABLE_FAILURE = 'ACCPSUPERVISORAVAILABLE_FAILURE';
export const ACCPSUPERVISORAVAILABLE_CLEAR = 'ACCPSUPERVISORAVAILABLE_CLEAR';
export function fetchACCPSupervisor(params = {}) {
	return async dispatch => {
        dispatch(accpSupervisorBegin());
        await ApiService.getEmployeeSupervisor(params)
			.then(
            result => {
                let normalized = normalizeById(result.Data, 'employeeId');
                    dispatch(accpSupervisorAdd(normalized));
					return normalized;
				},
				error => {
                    dispatch(accpSupervisorError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchACCPSupervisorFilter(params = {}) {
    return async dispatch => {
        await ApiService.getEmployeeSupervisorFilter(params)
            .then(
                result => {
                    dispatch(accpSupervisorFilterAdd(result));
                },
                error => {
                    dispatch(accpSupervisorFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchACCPSupervisorAvailable(params = {}) {
    return async dispatch => {
        dispatch(accpSupervisorAvailableBegin());
        await ApiService.getEmployeeSupervisorAvailable(params)
            .then(
            result => {
                dispatch(accpSupervisorAvailableAdd(result));
                },
                error => {
                    dispatch(accpSupervisorAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//ACCPSupervisor
export const accpSupervisorBegin = () => ({
    type: ACCPSUPERVISOR_BEGIN,
});

export const accpSupervisorAdd = data => ({
    type: ACCPSUPERVISOR_ADD,
	payload: { data }
})

export const accpSupervisorError = () => ({
    type: ACCPSUPERVISOR_FAILURE,
})

export const accpSupervisorClear = () =>({
    type: ACCPSUPERVISOR_CLEAR,
})

//ACCPSupervisor Filters
export const accpSupervisorFilterBegin = () => ({
    type: ACCPSUPERVISOR_FILTER_BEGIN,
});
export const accpSupervisorFilterAdd = filterData => ({
    type: ACCPSUPERVISOR_FILTER_SUCCESS,
    payload: { filterData }
})
export const accpSupervisorFilterError = filterError => ({
    type: ACCPSUPERVISOR_FILTER_FAILURE,
    payload: { filterError }
})

export const accpSupervisorFilterClear = () => ({
    type: ACCPSUPERVISOR_FILTER_CLEAR,
})

//ACCPSupervisorAvailable
export const accpSupervisorAvailableBegin = () => ({
    type: ACCPSUPERVISORAVAILABLE_BEGIN,
});

export const accpSupervisorAvailableAdd = data => ({
    type: ACCPSUPERVISORAVAILABLE_ADD,
    payload: { data }
})

export const accpSupervisorAvailableError = () => ({
    type: ACCPSUPERVISORAVAILABLE_FAILURE,
})

export const accpSupervisorAvailableClear = () => ({
    type: ACCPSUPERVISORAVAILABLE_CLEAR,
})
